//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
    components: {
        'review-applicant-screening': require('./ReviewApplicantScreening'),
        'failure-notes': require('./FailureNotes'),
        'applicant-payment': require('./ApplicantPayment'),
        'applicant-convert-to-resident': require('./ApplicantConvertToResident'),
        'applicant-credit-check': require('./ApplicantCreditCheck')
    },
    data: function data() {
        return {
            Loading: false,
            stillLoading: true,
            showEditIcon: false,
            showTransunion: true,
            EditApplicant: false,
            transunionRetrieval: false,
            isLoading: false,
            check_role: false,
            evaluate: false,
            isFailure: false,
            config: {
                dateFormat: 'Y-m-d'
            },
            applicant: {
                person: {}
            },
            resident_identity: {},
            audit: {},
            identityAudit: {},
            trans_union: {},
            convertApp: {},
            unit: {},
            transunion_id: "",
            units: [],
            pendingUnits: [],
            unitsForSelect: [],
            applicationData: this.applicant ? this.application.application_data : null,
            creditCheck: {},
            checkStatus: 1,
            errorText: '',
            applicationNumber: '',
            addPaymentShow: false,
            applicant_status: ['pending', 'active', 'suspended'],
            contact_preferences: ['SMS', 'Email', 'Phone', 'Mail'],
            sources: ['Drive by', 'Resident referral', 'Former resident referral', 'Employee referral', 'Other word of mouth', 'Other Community referral', 'Google', 'Property website', 'Zillow', 'Trulia', 'Costar', 'Rentpath', 'Craigs list', 'Facebook Marketplace', 'Apartment Locator service', 'Flyer, Radio, Newspaper advertisement'],
            pet_breeds: ['Pit Bull Terriers', 'Staffordshire Terriers', 'Rottweilers', 'German Shepherds', 'Presa Canarios', 'Chows Chows', 'Doberman Pinschers', 'Akitas', 'Wolf-hybrids', 'Mastiffs', 'Cane Corsos', 'Great Danes', 'Alaskan Malamutes', 'Siberian Huskies'],
            hasBedrooms: false,
            statuses: ['active', 'moved in', 'declined', 'withdrawn', 'referred'],
            bedroomsSelect: [{
                label: 'Studio',
                value: 0
            }, {
                label: '1',
                value: 1
            }, {
                label: '2',
                value: 2
            }, {
                label: '3',
                value: 3
            }],
            applicantValidations: [{ model: 'applicant.person.phone', rules: 'required' }, { model: 'applicant.person.email', rules: 'required' }, { model: 'unit.id', rules: 'required | integer | min:1' }, { model: 'applicant.person.move_in_date', rules: 'required | date' }],
            transUnionRetrievalRules: [{ model: 'applicant.id', rules: 'required' }, { model: 'applicationNumber', rules: 'required' }]
        };
    },

    watch: {
        applicant: function applicant(newData, oldData) {
            this.applicant = newData;
            this.unit = newData.unit;
            console.log(this.unit);
            this.applicationStatus(this.applicationData, this.applicant);
        },
        applicationData: function applicationData(newData, oldData) {
            this.applicationData = newData;
            this.applicationStatus(this.applicationData, this.applicant);
        }
    },
    computed: {
        occupantCount: function occupantCount() {
            return this.applicant && this.applicant.occupants ? this.applicant.occupants.length : 0;
        },
        leasingAgents: function leasingAgents() {

            return this.users.map(function (u) {
                return {
                    label: '(' + u.id + ') ' + u.first_name + ' ' + u.last_name,
                    id: '' + u.id
                };
            });
        }
    },
    methods: {
        openScreenApplicationSlide: function openScreenApplicationSlide() {
            Event.$emit('Screening Application');
        },
        openResidentIdentityVerificationSlide: function openResidentIdentityVerificationSlide() {
            Event.$emit('Resident Identity Verification');
        },
        openApplicationReviewSlide: function openApplicationReviewSlide(item, audit) {
            Event.$emit('Review Application', item, audit);
        },
        openFailureNotesSlide: function openFailureNotesSlide(item, identityAudit) {
            Event.$emit('Failure Notes', item, identityAudit);
        },
        showCalculator: function showCalculator() {
            Event.$emit('show-move-in-calculator', this.applicant, this.unit, this.unitsForSelect);
        },
        showProratedCalculator: function showProratedCalculator() {
            Event.$emit('show-prorated-calculator', this.applicant, this.unit, this.unitsForSelect);
        },
        confirmArchiveApplicant: function confirmArchiveApplicant() {
            Event.$emit('confirm-archive-applicant', this.applicant.status);
        },
        setBedrooms: function setBedrooms(bedroom) {
            if (this.EditApplicant) {
                this.$set(this.applicant.person, 'desired_bedrooms', bedroom.value);
            }
        },
        markApplicationsPaid: function markApplicationsPaid() {
            var _this = this;

            console.log('marking application paid');
            var self = this;
            var sendData = {
                applicant: this.applicant.id
            };

            axios.post('/prototype/person/applicants/mark-application-paid', sendData).then(function (response) {
                _this.addPaymentShow = false;
                _this.checkStatus = 3;
                _this.$snotify.success('The application is now paid! Once it is processed, you will be able to view it and approve.');
            });
        },
        getUnits: function getUnits() {

            var self = this;

            axios.get('/prototype/properties/nestio-available-units').then(function (response) {
                if (response.data) {
                    self.units = response.data.filter(function (unit) {
                        return unit.status != 'Pending Approval';
                    });
                    self.pendingUnits = response.data;
                    self.unitsForSelect = self.units.map(function (u) {
                        return {
                            label: u.name,
                            value: u.id,
                            price: u.rent_amount,
                            nestio_unit_id: u.nestio_unit_id
                        };
                    });
                }
            });
        },
        statusText: function statusText(status) {
            // @TODO: this can be cleaned up at the end; we don't go through all this anymore
            if (this.checkStatus == 1) {
                return 'Application Submitted';
            } else if (this.checkStatus == 2) {
                return 'Application Paid';
            } else if (this.checkStatus == 3) {
                return 'Application Gathered';
            } else if (this.checkStatus == 4) {
                return 'Pending Credit/Background Check';
            } else if (this.checkStatus == 5) {
                return 'Approved';
            } else if (this.checkStatus == 6) {
                return 'Lease Sent';
            } else if (this.checkStatus == 7) {
                return 'Lease Signed';
            } else if (this.checkStatus == 8) {
                return 'Lease Executed';
            } else if (this.checkStatus == 9999) {
                return 'Applicant Declined';
            } else {
                return 'N/A';
            }
        },
        addPayment: function addPayment() {
            Event.$emit('resident-add-payment');
            this.addPaymentShow = true;
        },
        addTransaction: function addTransaction() {
            Event.$emit('show-gl-wizard', this.applicant, true);
        },
        getSignaturePDF: function getSignaturePDF() {
            axios.post('/prototype/person/applicants/get-esignature-pdf', { id: this.applicant.id }).then(function (response) {
                return response.data;
            });
        },
        prepareAndValidateApplicantRecord: function prepareAndValidateApplicantRecord() {
            var _this2 = this;

            // Not sure we need validation here since most of this
            // isn't required to create an applicant
            /*
            this.validator
                .setRules(this.applicantValidations)
                .validate();
            if(this.validator.fails()) {
                return;
            }
            */
            this.EditApplicant = false;
            this.Loading = false;
            var form = document.querySelector('form');
            var formData = new FormData(form);
            formData.append("id", this.applicant.person.id);
            formData.append("applicant", this.applicant.id);
            if (this.unit) {
                formData.append('unit_id', this.unit.id);
                if (this.unit.nestio_unit_id) {
                    formData.append('nestio_unit_id', this.unit.nestio_unit_id);
                } else {
                    var unit = this.pendingUnits.filter(function (unit) {
                        return unit.id === _this2.unit.id;
                    });
                    formData.append('nestio_unit_id', unit.length ? unit[0].nestio_unit_id : '');
                }
            } else {
                formData.append('unit_id', 0);
            }
            formData.append("first_name", this.applicant.person.first_name);
            formData.append("last_name", this.applicant.person.last_name);
            formData.append("phone", this.applicant.person.phone);
            formData.append("email", this.applicant.person.email);
            formData.append("contact_preference", this.applicant.person.contact_preference);
            formData.append("address", this.applicant.person.address);
            formData.append("city", this.applicant.person.city);
            formData.append("state", this.applicant.person.state);
            formData.append("postal", this.applicant.person.postal);
            formData.append("desired_bedrooms", this.applicant.person.desired_bedrooms);
            formData.append("notes", this.applicant.person.notes);
            formData.append("source", this.applicant.person.source ? this.applicant.person.source : '');
            formData.append("additional_occupants", this.applicant.person.additional_occupants);
            formData.append("status", this.applicant.status);
            formData.append("background_check", this.applicant.passed_background_check);
            formData.append("credit_check", this.applicant.credit_check);
            formData.append("move_in_date", this.applicant.person.move_in_date != null ? this.applicant.person.move_in_date : '');
            formData.append("pets", this.applicant.person.pets);
            formData.append("pet_breed_status", this.applicant.person.pet_breed_status);
            formData.append("nestio_id", parseInt(this.applicant.nestio_id || 0));
            formData.append("prospect_id", parseInt(this.applicant.prospect_id || 0));
            formData.append("source", this.applicant.person.source);
            formData.append("selected_agent", this.selected_agent ? this.selected_agent.id : 0);
            return formData;
        },
        onSuccessOfUpdateApplicant: function onSuccessOfUpdateApplicant($el, response) {
            $el.applicant = response.data;
            $el.prospect = response.data.person && response.data.person.prospect ? response.data.person.prospect : '';
            if ($el.prospect) {
                $el.applicant.prospect_id = $el.prospect.id;
                $el.applicant.nestio_id = $el.prospect.nestio_id;
            }
            $el.unit = response.data.unit;

            $el.EditApplicant = false;

            $el.Loading = false;
            this.$snotify.success("Applicant updated successfully.");
            Event.$emit('updated-pending-applicants-list');
            Event.$emit('updated-applicants-list');
        },
        updateApplicant: function updateApplicant() {
            var _this3 = this;

            var convert = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            var $el = this;
            var formData = this.prepareAndValidateApplicantRecord();

            axios.post('/prototype/applicants/updatePerson', formData).then(function (response) {
                if (response.data) {
                    _this3.onSuccessOfUpdateApplicant($el, response);
                    if (convert === true) {
                        _this3.prepareConvertPayload();
                        Event.$emit('convert-applicant', _this3.convertApp);
                    }
                }
            });
        },
        applicationStatus: function applicationStatus(app, applicant) {

            // Application Submitted
            this.checkStatus = 1;

            // Application Paid
            if (applicant && applicant.is_paid) {
                this.checkStatus = 2;
                if (app && app.id) {
                    // Application Gathered
                    if (app.application) {
                        this.checkStatus = 3;
                    } else {
                        return false;
                    }

                    // Pending Credit/Background Check
                    if (app.credit_check) {
                        this.checkStatus = 4;
                        this.creditCheck = app.credit_check;
                        this.applicant.passed_background_check = app.credit_check.criminalRecommendation_code;
                        this.applicant.credit_check = app.credit_check.recommendation_code;
                    } else {
                        return false;
                    }

                    // Approved
                    if (app.approved) {
                        this.checkStatus = 5;
                    } else {
                        return false;
                    }

                    // Lease Sent
                    if (applicant.leases.length) {
                        this.checkStatus = 6;
                    } else {
                        return false;
                    }

                    // Lease Signed
                    if (app.application && app.application.ready_for_execution) {
                        this.checkStatus = 7;
                        // Lease Executed
                        if (app.application.executed) {
                            this.checkStatus = 8;
                        }
                    }
                    return false;
                }
            }

            if (applicant && applicant.status === 'suspended') {
                this.checkStatus = 9999;
            }
        },
        prepareConvertPayload: function prepareConvertPayload() {
            var _this4 = this;

            if (this.unit && this.unit.nestio_unit_id) {
                this.convertApp.nestio_unit_id = this.unit.nestio_unit_id;
            } else if (this.unit) {
                var unit = this.pendingUnits.filter(function (unit) {
                    return unit.name === _this4.unit.name;
                });
                this.convertApp.nestio_unit_id = unit.length ? unit[0].nestio_unit_id : '';
            }
            this.convertApp.move_in_date = moment(this.applicant.person.move_in_date).format("MM/DD/YYYY");
            this.convertApp.lease_start_date = this.convertApp.move_in_date;
            this.convertApp.email = this.applicant.person.email;
            this.convertApp.unitId = this.unit ? this.unit.id : '';
            this.convertApp.unit_name = this.unit ? this.unit.name : '';
            this.convertApp.unit_status = this.unit ? this.unit.status : '';
            this.convertApp.actual_rent_amount = this.unit ? this.unit.market_rent_amount : '';
            this.convertApp.lease_expire_date = moment(this.convertApp.lease_start_date).subtract(1, 'days').add(1, 'years').format("MM/DD/YYYY");
            this.convertApp.rent_amount = this.unit ? this.unit.rent_amount : '';
            this.convertApp.unit_amenities = this.unit && this.unit.amenities ? this.unit.amenities : '';

            this.person = this.applicant.person;
        },
        selectMoveInType: function selectMoveInType() {
            this.prepareConvertPayload();
            Event.$emit('select-move-in-type', this.convertApp);
        },
        updateStep: function updateStep(step) {
            this.checkStatus = step;
        },
        viewApplicant: function viewApplicant(item) {
            this.convertApp = item;
            var $el = this;
            $el.EditApplicant = false;
            $el.transunionRetrieval = false;
            $el.$children[0].$data.showModal = true;
            $el.checkStatus = 1;

            axios.post('/prototype/applicants/getApplicantDetail', {
                id: item.id
            }).then(function (response) {
                if (response.data) {
                    $el.applicant = response.data.applicant;
                    $el.showEditIcon = $el.applicant.status === 'active' || $el.applicant.status === 'pending';
                    $el.audit = response.data.audit;
                    $el.identityAudit = response.data.identityAudit;
                    var trans_union = response.data.applicant.person.trans_union;

                    $el.trans_union = trans_union;
                    var transunion_property_id = $el.applicant.property.transunion_property_id;

                    $el.transunion_id = transunion_property_id;
                    $el.unit = $el.applicant.unit;
                    $el.applicant.nestio_id = $el.applicant.person && $el.applicant.person.prospect ? $el.applicant.person.prospect.nestio_id : 0;
                    $el.applicant.prospect_id = $el.applicant.person && $el.applicant.person.prospect ? $el.applicant.person.prospect.id : 0;
                    // Event.$emit( 'refresh-applicant-ledger', $el.applicant );
                    $el.stillLoading = false;
                    $el.getUnits();
                    $el.check_role = window.user.role === 'super-admin';
                    $el.resident_identity = $el.applicant.resident_identity_verification;
                    $el.evaluate = !!($el.resident_identity && $el.resident_identity.risk_indicator);
                    $el.isFailure = !!($el.resident_identity && $el.resident_identity.result && $el.resident_identity.result.toLowerCase() === 'fail');
                    $el.selected_agent = $el.applicant.person && $el.applicant.person.leasing_agent ? { 'id': $el.applicant.person.leasing_agent.id, 'label': $el.applicant.person.leasing_agent.first_name + ' ' + $el.applicant.person.leasing_agent.last_name } : '';
                    $el.showTransunion = !!$el.transunion_id;
                }
            });

            // @TODO: this makes a Portal Helper call; may be obsolete as well
            axios.post('/prototype/person/applicants/get-applications', { id: item.id }).then(function (response) {
                if (response.data) {
                    $el.applicationData = response.data;
                    $el.applicationStatus($el.applicationData, $el.applicant);
                }
            });
        },
        transUnionRetrieval: function transUnionRetrieval() {
            var _this5 = this;

            this.validator.setRules(this.transUnionRetrievalRules).validate();
            if (this.validator.fails()) {
                var errors = [];
                errors = this.validator.errorsBag;
                var msg = '';
                errors.forEach(function (error) {
                    msg += error.message + '(' + error.model + ')' + '.';
                });
                this.$snotify.error(msg);
            } else {
                this.isLoading = true;
                axios.post('/prototype/link-transunion-application', { sourceRef: this.applicant.id, applicationNumber: this.applicationNumber }).then(function (response) {
                    _this5.isLoading = false;
                    _this5.transunionRetrieval = false;
                    _this5.applicationNumber = "";
                    if (response.data) {
                        _this5.applicationNumber = '';
                        _this5.transunionRetrieval = false;
                        _this5.$snotify.success('The Retrieve was successful');
                        Event.$emit("close-full-modal");
                        Event.$emit("view-applicant", _this5.applicant);
                        Event.$emit('link Screening Application', response.data);
                    }
                }).catch(function (err) {
                    _this5.isLoading = false;
                });
            }
        },
        getUsers: function getUsers() {
            var _this6 = this;

            axios.get('/prototype/users/all').then(function (response) {
                _this6.users = response.data;
            });
        }
    },
    created: function created() {
        var _this7 = this;

        Event.$on('view-applicant', function (item) {
            _this7.viewApplicant(item);
            _this7.getUsers();
        });
        Event.$on('update-step', this.updateStep);
        Event.$on('mark-application-paid', this.markApplicationsPaid);
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('view-applicant');
        Event.$off('update-step');
        Event.$off('mark-application-paid');
    },
    mounted: function mounted() {
        this.$initValidator();
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/person/applicants/ApplicantDetails.vue
// module id = nvx5
// module chunks = 0 1